import { render, staticRenderFns } from "./offerViewIndex.vue?vue&type=template&id=55f1b574&scoped=true&"
import script from "./offerViewIndex.vue?vue&type=script&lang=js&"
export * from "./offerViewIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f1b574",
  null
  
)

export default component.exports